import { CSSProperties, ReactNode, ReactElement } from 'react';
import styles from './ui-card.module.scss';

type UICardProps = {
    children?: ReactNode;
    style?: CSSProperties;
    className?: string;
    variant?: 'raised' | 'flat';
};
export function UICard(props: UICardProps): ReactElement {
    const { children, style, className, variant = 'raised' } = props;

    const classes = [className, styles.container, styles[variant]];
    return (
        <div className={classes.join(' ')} style={style}>
            <div className={styles.innerContainer}>{children}</div>
        </div>
    );
}
